import React from 'react'
import ArrowRightIcon from '@dustin-web/microsite-components/src/icon/generated/arrow-right'
import { BannerAd } from '.'
import { TicketLink } from '@dustin-web/product-components/src/ticket-link'
import Image from 'next/image'

type AdsProps = {
  ad: BannerAd
}

const BannerProductbox = ({ ad }: AdsProps) => {
  if (ad.banner?.displayMode !== 'ProductBox') {
    return null
  }

  if (!ad.banner.url) {
    return null
  }

  return (
    <div className="c-filter__product-list c-filter__product-list--ad-productbox s-product-cards">
      <div className="s-panel row sm-gutters">
        <div className="col-12 u-px-8 u-mb-16">
          <div className="c-product-card c-product-card--list c-product-card--ad-productbox">
            {ad.banner.imageUrl && (
              <div className="c-banner-productbox-image">
                <TicketLink url={ad.banner.url} ticket={ad.ticket}>
                  <Image src={ad.banner.imageUrl} alt={ad.banner.text || ''} />
                </TicketLink>
              </div>
            )}

            <div className="c-product-card__product-info">
              <div className="d-flex flex-column flex-fill">
                <div className="mb-4 flex-fill">
                  <div className="c-product-card-title">
                    <TicketLink url={ad.banner.url} ticket={ad.ticket} className="h3">
                      {ad.banner.text || ''}
                    </TicketLink>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column">
                <div className="flex-fill"></div>
                <div className="d-none d-sm-block">
                  <TicketLink
                    url={ad.banner.url}
                    ticket={ad.ticket}
                    className="c-btn c-btn--primary c-btn--w-icon">
                    {ad.banner.buttonText}
                    <ArrowRightIcon className="c-btn__icon i-20" />
                  </TicketLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BannerProductbox
